<template>
  <div class="thumb type-cell">
    <a href="#"
       @click.prevent="goDetail(cellInfo)"
       aria-labelledby="type-cell-title-1-1 type-cell-title-1-2">
      <div class="sub-title">
        <div class="sub-right" ref="title"
          v-title-list="{
            'titleList':titleList,
            'cellType': 'landscape'
          }">
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import _ from 'lodash'
import { titleList } from '@/common/resources/directives'
import CellMixIn from '@/mixins/cell.mixin'
export default {
  name: 'KeywordLine2Cell',
  mixins: [
    CellMixIn
  ],
  directives: {
    titleList
  },
  props: {
    cellInfo: {
      type: Object
    }
  },
  computed: {
    titleList () {
      return _.get(this.cellInfo, 'title_list', [])
    }
  }
}
</script>
